import prettyAmount from './prettyAmount'
import formatNumber from './formatNumber'

const resolveAmount = amount => {
  switch (typeof amount) {
    case 'number':
      return prettyAmount(amount)
    case 'string': {
      const dIndex = amount.indexOf('.')
      return dIndex > -1
      ? amount.slice(0, dIndex + 3).padEnd(dIndex + 3, '0')
      : amount
    }
    case 'object':
      return amount.toFixed(2)
  }
}

const formatUsdAmount = amount => `$${formatNumber(resolveAmount(amount))}`

export default formatUsdAmount
